module.exports = __webpack_public_path__ + "img/profitability9.d14c6fe0.png";